import React, { useState } from 'react';
import { Alert, Box, Card, CardContent, Tab, Tabs } from '@mui/material';
import { useAccessControl } from '../../hooks/useAccessControl';
import { RESOURCES, ACTIONS } from '../../hooks/usePermissions';
import ModulePageHeader from '../common/ModulePageHeader';
import AssetCategoriesTab from './assets/AssetCategoriesTab';
import AssetRegisterTab from './assets/AssetRegisterTab';
import DepreciationTab from './assets/DepreciationTab';

const TABS = [
  { value: 'register', label: 'Asset Register', Component: AssetRegisterTab },
  { value: 'categories', label: 'Categories', Component: AssetCategoriesTab },
  { value: 'depreciation', label: 'Depreciation', Component: DepreciationTab },
];

// Fixed Assets: the school's physical register (config/ledger.php section
// 'assets') - categories own the depreciation policy and GL legs, the
// register holds one row per asset, depreciation runs post the periodic
// charge. Disposals live on the register row (gain/loss posts on dispose).
const Assets = () => {
  const { can } = useAccessControl();
  const [tab, setTab] = useState('register');

  if (!can(RESOURCES.LEDGER.ASSETS, ACTIONS.READ)) {
    return <Alert severity="error">You do not have permission to view Assets.</Alert>;
  }

  const Active = TABS.find((t) => t.value === tab)?.Component;

  return (
    <Box>
      <ModulePageHeader
        title="Assets"
        subtitle="Fixed asset register, categories and depreciation"
      />
      <Card sx={{ mb: 3 }}>
        <CardContent sx={{ pb: '8px !important', pt: '4px !important' }}>
          <Tabs value={tab} onChange={(_, v) => v && setTab(v)} variant="scrollable" scrollButtons="auto">
            {TABS.map((t) => (
              <Tab key={t.value} value={t.value} label={t.label} />
            ))}
          </Tabs>
        </CardContent>
      </Card>

      {Active && <Active />}
    </Box>
  );
};

export default Assets;
